import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {TimelineAuthor} from '../TimelineAuthor'

export function AssignedText({info}: {info: IssueEventInfo}) {
  const {eventType, assigneeLogin} = info
  if (!assigneeLogin) return <>{eventType}</>
  return (
    <>
      {eventType} <TimelineAuthor login={assigneeLogin} />
    </>
  )
}
